module.exports = __webpack_public_path__ + "img/patchouli knowledge_lw.20efc326.png";